export const FLOW_NAMES = {
    LONG_PREQUAL: 'long_prequal',
    TWO_STEP_PREQUAL: 'two_step',
    LEAD_FIRST: 'lead_first',
    CW_PREQUAL: 'camping_world_prequal',
    DIGITAL_CREDIT_APP: 'digital_credit_app',
};
